import { useTranslation } from 'react-i18next';
import { useDashboardStore } from '../../stores/Layout/dashboard'

const FollowMission = () => {
  const { t } = useTranslation();
  const { followMissions } = useDashboardStore();

  return (
    <div className="w-full h-full flex flex-col justify-start items-start bg-white">
      {/* Affichage des missions suivi en temps réel */}
      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 mb-4 h-auto">
        <div className="p-2 sm:p-3 bg-yellow-trio rounded-xl self-start sm:self-center">
          <svg className="w-5 h-5 sm:w-6 sm:h-6 text-grey-trio" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div className="flex-1">
          <h1 className="text-lg sm:text-xl font-bold text-gray-700 font-K2D">
            {t("dashboard.followedMissionsTitle")}
          </h1>
          <p className="text-sm sm:text-md text-gray-600 mt-1">
            {t("dashboard.followedMissionsSubtitle")}
          </p>
        </div>
      </div>
      <div className="w-full h-full flex flex-col justify-start items-center bg-white mb-4 p-2 sm:p-4 gap-3 sm:gap-4 overflow-y-auto">
        {followMissions?.length > 0 ? followMissions.map((item: any) => (
          <div key={item.id} className="w-full h-auto flex flex-col justify-start items-start border border-gray-100 rounded-xl bg-white shadow-md p-2 sm:p-3">
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center w-full gap-2">
              <h1 className="text-base sm:text-lg lg:text-xl font-bold text-gray-700 font-K2D">
                <span className="text-yellow-trio text-sm sm:text-md mb-2">#{item.fakeId}</span> {item.name}
              </h1>
              <p className="hidden 2xl:block text-xs sm:text-sm text-gray-600">{t("dashboard.requestsCount")} : <span className="font-bold">{item.amountDocRequests}</span></p>
            </div>
            <p className="text-xs sm:text-sm text-gray-600 italic ml-6 mt-1">{t("dashboard.manager")} : <span className="font-bold">{item.managerName}</span></p>

            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center w-full mt-2 border border-gray-100 p-2 rounded-xl gap-2">
              <div className="flex justify-start items-center gap-2">
                <div className="p-1.5 sm:p-2 bg-dark-lavender rounded-xl">
                  <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="none" stroke="#ffffff" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                {item?.latestDocumentUploaded === null ? <p>{t("dashboard.noDocumentYet")}</p> : <p className="text-xs sm:text-sm text-gray-600">{t("dashboard.documentsCount")} : <span className="font-bold">{item.amountDocuments}</span></p>}
              </div>
              {item?.latestDocumentUploaded !== null && <p className="text-xs sm:text-sm text-gray-600 text-center sm:text-right">{t("dashboard.lastDepositOn")} : <span className="font-bold">{item?.latestDocumentUploaded}</span></p>}
            </div> 
          </div>
        )) : 
          <div className="text-center py-12">
            <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">{t("dashboard.noFollowedMissionTitle")}</h3>
            <p className="text-gray-500">{t("dashboard.noFollowedMissionText")}</p>
          </div>
        }
      </div>
    </div>
  )
}

export default FollowMission
